import React from 'react'

const Why = () => {
  return (
    <>
     <div className="container-fluid py-5 bgimg2">
        <div className="container pt-5 pb-3 ">
            <h1 className="display-4 text-uppercase text-center mb-5">What Are You Paying For?</h1>
            <div className="row">
                <div className="col-lg-3 mb-2">
                    <div className="service-item rounded p-4 mb-4">
                        <i className="fa fa-3x fa-solid fa-award text-primary mb-4"></i>
                        <h4 className="text-uppercase mb-4"><span className="d-block text-body">Experience</span></h4>
                        <p className="m-0">
                            My 5 Years of experience has helped  in developing and designing websites enables me to create stunning websites that are both visually appealing and highly functional."</p>
                    </div>
                </div>
                <div className="col-lg-3 mb-2">
                    <div className="service-item rounded p-4 mb-4">
                        <i className="fa fa-3x fa-code text-primary mb-4"></i>
                        <h4 className="text-uppercase mb-4"><span className="d-block text-body">Strong design skills</span></h4>
                        <p className="m-0">
                            From layouts to color schemes and imagery, I pay close attention to every detail to ensure that the final product meets both the client's needs and my own high standards for design.</p>
                    </div>
                </div>
                <div className="col-lg-3 mb-2">
                    <div className="service-item rounded p-4 mb-4">
                        <i className="fa fa-3x fa-edit text-primary mb-4"></i>
                        <h4 className="text-uppercase mb-4"> <span className="d-block text-body">Analytical skills</span></h4>
                        <p className="m-0">
                            I analyze user behavior and feedback to understand how visitors are interacting with the website, and then optimize the design to maximize conversions and user engagement.</p>
                    </div>
                </div>
                <div className="col-lg-3 mb-2">
                    <div className="service-item rounded p-4 mb-4">
                        <i className="fa fa-3x fa-chess-knight text-primary mb-4"></i>
                        <h4 className="text-uppercase mb-4"><span className="d-block text-body">Strategies</span></h4>
                        <p className="m-0">
                            I am able to ensure that every element of the website is designed with intention and purpose, resulting in a final product that not only looks great but also drives real results for my clients.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default Why